export default __webpack_public_path__ + "static/media/arrow-down-blue.f81e1fe9.svg";